
import React, { useEffect, useState } from 'react';

const Counter = ({ count = 0, onChange, measurement = "Feet", min = 0, max = Infinity }) => {
    const [inputValue, setInputValue] = useState(String(count));

    useEffect(() => {
        setInputValue(String(count));
    }, [count]);


    const isDecimal = count % 1 !== 0;

    const handleDecrement = () => {
        if (count > min) {
            const newValue = Number(count) - 0.5;
            onChange(isDecimal ? Math.floor(count) : newValue);
        }
    };

    const handleIncrement = () => {
        if (count < max) {
            const newValue = Number(count) + 0.5;
            onChange(isDecimal ? Math.ceil(count) : newValue);
        }
    };


    const handleInputChange = (e) => {
        const rawValue = e.target.value;
        setInputValue(rawValue);

        if (rawValue === '') {
            onChange(0);
        } else if (!isNaN(rawValue) && !isNaN(parseFloat(rawValue))) {
            const numericValue = Number(rawValue);
            if (numericValue >= min && numericValue <= max) {
                onChange(numericValue);
            }
        }
    };

    const handleInputBlur = () => {
        const numericValue = Number(inputValue);
        if (isNaN(numericValue) || inputValue === '') {
            setInputValue(String(count));
        } else {
            const clampedValue = Math.max(min, Math.min(max, numericValue));
            setInputValue(String(clampedValue));
            if (clampedValue !== count) {
                onChange(clampedValue);
            }
        }
    };

    const handleKeyDown = (e) => {
        if ([46, 8, 9, 27, 13, 110, 190].indexOf(e.keyCode) !== -1 ||
            (e.keyCode === 65 && e.ctrlKey === true) ||
            (e.keyCode === 67 && e.ctrlKey === true) ||
            (e.keyCode === 86 && e.ctrlKey === true) ||
            (e.keyCode === 88 && e.ctrlKey === true) ||
            (e.keyCode >= 35 && e.keyCode <= 40)) {
            return;
        }
        if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
            e.preventDefault();
        }
    };



    return (
        <div className="counter">
            <button className="counter__button counter__button--decrement" onClick={handleDecrement} disabled={count === 0}>-</button>
            <div className="counter__count-container">
                {/* <span className="counter__count">{count}</span> */}
                <input
                    type="text"
                    className="counter__count"
                    placeholder='0'
                    value={inputValue}
                    onChange={handleInputChange}
                    onBlur={handleInputBlur}
                    onKeyDown={handleKeyDown}
                />
                <span className="counter__measurement">{measurement}</span>
            </div>
            <button className="counter__button counter__button--increment" onClick={handleIncrement}>+</button>
        </div>
    );
};

export default Counter;